import { CredentialsManagerGridWebComponent } from './component/CredentialsManagerGridWebComponent';
import { WEB_COMPONENT_CREDENTIALS_MANAGER_GRID } from '../../../../webcomponents.constants';

export { CredentialsManagerGridWebComponent };

window.customElements.define(WEB_COMPONENT_CREDENTIALS_MANAGER_GRID, CredentialsManagerGridWebComponent);
